const LS_PREFIX = 'uls';

export const ACCESS_TOKEN = `${LS_PREFIX}_access_token`;
export const REFRESH_TOKEN = `${LS_PREFIX}_refresh_token`;
export const USER_ID = `${LS_PREFIX}_user_id`;
export const USER_EMAIL = `${LS_PREFIX}_user_email`;
export const USER_NAME = `${LS_PREFIX}_user_name`;
export const USER_EXPIRATION = `${LS_PREFIX}_user_expiration`;
export const EMPLOYEE_ID = `${LS_PREFIX}_employee_id`;
export const MATRIX_ID = `${LS_PREFIX}_matrix_id`;
export const COMPANY_IDS = `${LS_PREFIX}_company_ids`;
export const MODULE = `${LS_PREFIX}_module`;
export const SHOW_WITHOUT_MOVIMENTS = `${LS_PREFIX}_show_without_moviments`;
export const UC_SCHEDULE_COMPANY_ID = 'uc-schedule-companyId';
export const UG_HASH = 'ug-hash';
export const IS_MASTER_PASSWORD_AUTHENTICATION = `${LS_PREFIX}_is_master_password_authentication`;
